import React from 'react';

export interface WithDeviceProps {
  isMobileDevice: boolean;
}

const isMobileDevice = (): boolean => {
  // A simple regex to check for common mobile user agents
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
};

export const withDevice = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: Omit<P, keyof WithDeviceProps>) => {
    const [isMobile, setIsMobile] = React.useState<boolean>(false);

    React.useEffect(() => {
      setIsMobile(isMobileDevice());
    }, []);

    return <Component {...(props as P)} isMobileDevice={isMobile} />;
  };
}; 